import { render, staticRenderFns } from "./ProfileInterestCategories.vue?vue&type=template&id=68503921"
import script from "./ProfileInterestCategories.vue?vue&type=script&lang=js"
export * from "./ProfileInterestCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports